export interface IWeek {
  number: number
  name: string
  shortName: string
  isSunday: boolean
  isSaturday: boolean
}

export const weekdays: IWeek[] = [
  {
    number: 0,
    name: '日曜日',
    shortName: '日',
    isSunday: true,
    isSaturday: false
  },
  {
    number: 1,
    name: '月曜日',
    shortName: '月',
    isSunday: false,
    isSaturday: false
  },
  {
    number: 2,
    name: '火曜日',
    shortName: '火',
    isSunday: false,
    isSaturday: false
  },
  {
    number: 3,
    name: '水曜日',
    shortName: '水',
    isSunday: false,
    isSaturday: false
  },
  {
    number: 4,
    name: '木曜日',
    shortName: '木',
    isSunday: false,
    isSaturday: false
  },
  {
    number: 5,
    name: '金曜日',
    shortName: '金',
    isSunday: false,
    isSaturday: false
  },
  {
    number: 6,
    name: '土曜日',
    shortName: '土',
    isSunday: false,
    isSaturday: true
  }
]
